import { orderedSquares } from "../input/board-controls.js";

const PIECE_NAMES = Object.freeze({
  k: "king",
  q: "queen",
  r: "rook",
  b: "bishop",
  n: "knight",
  p: "pawn",
});

export function createBoardViewState(options) {
  const { view, orientation, selected, legal, focusedSquare, hint, settings } =
    options;
  const lastMove = view.history.at(-1) ?? null;
  const pieces = view.board.filter(Boolean).map((piece) => ({
    ...piece,
    name: PIECE_NAMES[piece.type],
    imageUrl: options.resolvePiece?.(piece.color, piece.type) ?? null,
  }));
  const checkPiece = view.status.check
    ? pieces.find((piece) => piece.type === "k" && piece.color === view.turn)
    : null;
  return Object.freeze({
    fen: view.fen,
    turn: view.turn,
    orientation,
    squares: Object.freeze(orderedSquares(orientation)),
    pieces: Object.freeze(pieces),
    selectedSquare: selected,
    legalMoves: Object.freeze(legal.map((move) => ({ ...move }))),
    focusedSquare,
    lastMove,
    lastMoveWasEngine: Boolean(options.lastMoveWasEngine),
    checkSquare: checkPiece?.square ?? null,
    hint: hint
      ? Object.freeze({
          stage: hint.stage,
          from: hint.move.from,
          to: hint.move.to,
        })
      : null,
    interactive: Boolean(options.interactive),
    playerSide: options.playerSide,
    localMode: Boolean(options.localMode),
    coordinates: Boolean(settings.coordinates),
    legalHighlights: Boolean(settings.legalHighlights),
    reducedMotion: Boolean(settings.reducedMotion),
    boardTextureUrl: options.boardTextureUrl ?? null,
    theme: Object.freeze({ ...options.theme }),
    pieceSetId: options.pieceSetId,
    pieceSet: options.pieceSet ?? null,
  });
}

export function squareLabel(square, state) {
  const piece = state.pieces.find((item) => item.square === square);
  const legal = state.legalMoves.some((move) => move.to === square);
  const hintSource = state.hint?.stage >= 2 && state.hint.from === square;
  const hintTarget = state.hint?.stage >= 3 && state.hint.to === square;
  return `${square}, ${piece ? `${piece.color === "w" ? "white" : "black"} ${piece.name}` : "empty"}${legal ? ", legal destination" : ""}${hintSource ? ", suggested piece" : ""}${hintTarget ? ", suggested destination" : ""}`;
}

export function squareToWorld(square) {
  return {
    x: square.charCodeAt(0) - 97 - 3.5,
    z: 3.5 - (Number(square[1]) - 1),
  };
}

export function worldToSquare(x, z) {
  const file = Math.floor(x + 4);
  const rank = Math.floor(4 - z);
  if (file < 0 || file > 7 || rank < 0 || rank > 7) {
    return null;
  }
  return `${String.fromCharCode(97 + file)}${rank + 1}`;
}

export function isMovablePiece(piece, state) {
  return Boolean(
    state.interactive &&
    piece?.color === state.turn &&
    (state.localMode || piece.color === state.playerSide),
  );
}
